export const GA_CLICK_ACTION = {
  BATCH_APPLY_WARRANTY: 'BATCH_APPLY_WARRANTY',
  BATCH_APPLY_ATTRIBUTE: 'BATCH_APPLY_ATTRIBUTE',
  BATCH_APPLY_COMPOSE_IMAGE: 'BATCH_APPLY_COMPOSE_IMAGE'
}

export const GA_KEY = {
  BATCH_APPLY_WARRANTY: 'BATCH_APPLY_WARRANTY',
  BATCH_APPLY_ATTRIBUTE: 'BATCH_APPLY_ATTRIBUTE',
  BATCH_APPLY_COMPOSE_IMAGE: 'BATCH_APPLY_COMPOSE_IMAGE'
}

export const GA_KEY_MAP = {
  [GA_KEY.BATCH_APPLY_WARRANTY]: 'confirm-batch-apply-warranty',
  [GA_KEY.BATCH_APPLY_ATTRIBUTE]: 'confirm-batch-apply-attribute',
  [GA_KEY.BATCH_APPLY_COMPOSE_IMAGE]: 'confirm-batch-apply-image'
}

export const GA_CATEGROY_MAP = {
  [GA_KEY.BATCH_APPLY_WARRANTY]: 'batch-Update Copy',
  [GA_KEY.BATCH_APPLY_ATTRIBUTE]: 'batch-Update Attribute',
  [GA_KEY.BATCH_APPLY_COMPOSE_IMAGE]: 'batch-Update Image'
}

export const GA_ACTION_MAP = {
  [GA_KEY.BATCH_APPLY_WARRANTY]: 'batch-apply Warranty',
  [GA_KEY.BATCH_APPLY_ATTRIBUTE]: 'batch-apply Attribute',
  [GA_KEY.BATCH_APPLY_COMPOSE_IMAGE]: 'batch-apply Image'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type } = action

  let key
  switch (type) {
    case GA_CLICK_ACTION.BATCH_APPLY_WARRANTY:
    case GA_CLICK_ACTION.BATCH_APPLY_ATTRIBUTE:
    case GA_CLICK_ACTION.BATCH_APPLY_COMPOSE_IMAGE:
      key = GA_KEY[type]
      break
    default:
      break
  }

  const i13nModel = {
    category: GA_CATEGROY_MAP[key],
    action: GA_ACTION_MAP[key],
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
